// Not generated from samples: written from Appboy::Communication::Segment::RefundValueCalculatedAttributeFilter.

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const refundValueCalculatedAttributeFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("refund_value_calculated_attribute_filter"),
  // strict_field :c enum: more than, at least, less than, at most, exactly
  comparison_key: z.enum(["1", "3", "4", "5", "6"]),
  display_name: z.string(),
  // Integer | Float; CalculatedAttributesFilterBase.build_from_json rejects negatives
  raw_value: z.number().min(0).optional(),
  value: z.number().min(0),
  varies_by_app_group: z.literal(true),
});
